import HTTP from './http-request-handler'
// import axios from 'axios'
import Vue from 'vue'

const signUpServices = {
  getPage: function (page) {
    return HTTP.get('document/download', { params: { ...page } })
      .then(response => {
        if (response.status === 200) {
          return response.data
        } else {
          return Promise.reject(new Error(`Error in fetchings page`))
        }
      }).catch(e => { return e })
  },
  getCountries: function () {
    return HTTP.get('countryList')
      .then(response => {
        if (response.status === 200) {
          return response.data.result.countries
        } else {
          return Promise.reject(new Error('Error in fetching Countries'))
        }
      }).catch(e => {
        return e
      })
  },
  getStatesByCountryCode: function (countryCode) {
    return HTTP.get('stateList?code=' + countryCode)
      .then(response => {
        return response.data.result.state
      }).catch(e => {
        return e
      })
  },
  initAccount: function (paramobj) {
    return HTTP.post('/subsInitAccount', { ...paramobj })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  verifyEmail: function (query) {
    return HTTP.post('/verifyEmail', { ...query })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  verifyEmailUpdate: function (query) {
    return HTTP.post('/verifyEmailUpdate', { ...query })
      .then(response => {
        return response.data
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  verifyOTP: function (query) {
    return HTTP.post('/verifyMobile', { ...query })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  validateMobile: function (query) {
    return HTTP.post('/validateMobile', { ...query })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  resendEmail: function (params) {
    return HTTP.post('/resendEmail', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  resendOTP: function (params) {
    return HTTP.post('/resendMobileOTP', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  completeAccount: function (params) {
    return HTTP.post('/completeAccount', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  completeAccountV2: function (params) {
    return HTTP.post('/completeAccountV2', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  twoFactorAuth: function (params) {
    return HTTP.post('/2falogin', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  resendTwoFaOTP: function (params) {
    return HTTP.post('/resendLoginCode', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  updateTaxCategory: function (payload) {
    return HTTP.post('/taxCategoryUpdate/approve', payload)
      .then(response => {
        return response
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  initAccountV2: function (paramobj) {
    return HTTP.post('/subsInitAccountV2', { ...paramobj })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  getCurrencyList: function () {
    return HTTP.get('getCurrencyList')
      .then(response => {
        if (response.status === 200) {
          return response.data.result.currencyList
        } else {
          return Promise.reject(new Error('Error in fetching Currencies'))
        }
      }).catch(e => {
        return e
      })
  },
}

export default signUpServices
